import React, { PureComponent, PropTypes } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import jack from 'jack-logs';
import styles from './styles.scss';
import FirstClockIn from './FirstClockIn';
import ClockConfirm from './ClockConfirm';

export class ClockIn extends PureComponent {
  constructor(props) {
    super(props);
    this.handleUndoClockin = this.handleUndoClockin.bind(this);
    this.handleFirstClockin = this.handleFirstClockin.bind(this);
    this.setCanvas = this.setCanvas.bind(this);
    this.state = {
      undone: false, canvas: null, id: this.props.currentUser.id,
    };
  }

  componentDidMount() {
    if (this.adminFirstClockIn()) {
      this.props.clearTimer();
    }
  }

  componentWillUpdate(props, state) {
    if (state.undone) {
      this.props.undoClockEntry();
      if (window.platform === 'ios' && this.props.shouldCapture) {
        window.camera.show();
      }
    }
  }

  componentWillUnmount() {
    if (!this.state.undone) {
      const { id } = this.state;
      if (window.NATIVE_INTERCOM) {
        window.intercom.logEvent('performed_clock');
      } else {
        window.Intercom('trackEvent', 'performed_clock'); // eslint-disable-line
      }
      const image = this.state.canvas;
      this.props.doClock(id, this.props.time, image, `clock${this.props.type}`);
    }

    document.removeEventListener('keydown', this.handleKeypress);
    this.props.clearFirstTimeClockingIn();
  }

  setCanvas(canvas) {
    this.setState({ canvas });
  }

  adminFirstClockIn() {
    return this.props.config && this.props.config.adminFirstClockIn;
  }

  handleUndoClockin(e) {
    e.stopPropagation();
    this.props.setAndStartTimer(5000); // 5 seconds on the previous screen
    this.setState({ undone: true });
    jack.log({ message: 'Undo button pressed', clockinType: this.props.type, passcode: this.props.currentUser.passcode });
  }

  handleFirstClockin() {
    this.props.clearUser();
    this.props.signUpRecordConversion();
  }

  render() {
    if (!this.props.currentUser.valid) {
      return null;
    }

    return (
      <div className={styles.ClockIn}>
        <div className={cn(styles.ClockInFlash, styles.go)} />
        {this.adminFirstClockIn() ? (
          <FirstClockIn
            setCanvas={this.setCanvas}
            features={this.props.features}
            clearUser={this.props.clearUser}
            signUpRecordConversion={this.handleFirstClockin}
          />
        ) : (
          <ClockConfirm
            currentUser={this.props.currentUser}
            clearUser={this.props.clearUser}
            features={this.props.features}
            onUndoClockin={this.handleUndoClockin}
            setCanvas={this.setCanvas}
            setAndStartTimer={this.props.setAndStartTimer}
            shiftDetails={this.props.shiftDetails}
            teams={this.props.teams}
            type={this.props.type}
          />
        )}
      </div>
    );
  }
}

ClockIn.propTypes = {
  config: PropTypes.object,
  doClock: PropTypes.func,
  undoClockEntry: PropTypes.func,
  setAndStartTimer: PropTypes.func,
  clearUser: PropTypes.func,
  signUpRecordConversion: PropTypes.func,
  type: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  toggleFlash: PropTypes.func,
  currentUser: PropTypes.object,
  clearTimer: PropTypes.func,
  clearFirstTimeClockingIn: PropTypes.func,
  teams: PropTypes.array.isRequired,
  shiftDetails: PropTypes.array.isRequired,
};

export default connect(state => ({
  currentUser: state.get('currentUser').toJS(),
}))(ClockIn);



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/home/ClockIn/index.jsx